import React, { useEffect, useState } from "react";
import CommonService from "../../services/common.service";
import { Link } from "react-router-dom";
import ToastComponent from "../Common/TaostComponent";
import AccountShareModal from "./AccountShareModal";

const GuestCommonheader = (props) => {
  const [accountDetails, setAccountDetails] = useState({});
  const userDetails = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    if (props.accountName) {
      CommonService.userAllGame(props.accountName).then((res) => {
        if (res.status === 200) {
          setAccountDetails(res.accountDetails);
        }
      });
    }
  }, []);
  const copyToClipboard = () => {
    // Create a temporary input element
    const tempInput = document.createElement("textarea");
    tempInput.value = `${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${props.accountName}`;
    document.body.appendChild(tempInput);

    // Select the text in the input element
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to the clipboard
    document.execCommand("copy");

    ToastComponent("Fantasy Hub name copied to clipboard!", "success");
    // Remove the temporary input element
    document.body.removeChild(tempInput);
  };

  // Show Game share Modal
  const [showAccountShareModal, setShowAccountShareModal] = useState(false);
  const handleAccountShareModal = (e, clubId, itemDetail) => {
    e.preventDefault();
    setShowAccountShareModal(true);
  };
  return (
    <>
      <div className="banner-section">
        <div className="banner-content">
          <div className="left-section">
            <figure>
              <img
                src={`${process.env.REACT_APP_CLUB_PROFILE}${accountDetails?.club_logo}`}
                alt="mct_image"
              />
            </figure>
            <div className="gamebar_detail">
              <h2>{accountDetails?.club_name}</h2>
              {userDetails && (
                <ul className="game-btn">
                  <li>
                    <Link to={`/my-games`}>My Games</Link>
                  </li>
                </ul>
              )}
              {!userDetails && (
                <ul className="game-btn">
                  <li>
                    {" "}
                    <Link
                      to={`/account-hub?account_name=${props.accountName}`}
                      className=""
                    >
                      <i className="fas fa-home"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/member-signup?account_name=${props.accountName}`}
                    >
                      Sign-Up
                    </Link>
                  </li>
                  <li>
                    <Link to={`/login`}>Login</Link>
                  </li>
                  <li>
                    <Link onClick={handleAccountShareModal}>
                      <i class="fas fa-envelope-open-text"></i>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <div className="dropdown ">
                      <Link
                        className="dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-bars"></i>
                      </Link>
                      <ul
                        className="dropdown-menu mobiledropdownmenu logindropdown"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <Link
                            className="dropdown-item custom_dd_class"
                            to="/how-to-play"
                          >
                            How To Play
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/rules"}
                            className="dropdown-item custom_dd_class"
                          >
                            Rules
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item custom_dd_class"
                            to="/faqs"
                          >
                            FAQs
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      <AccountShareModal
        showAccountShareModal={showAccountShareModal}
        setShowAccountShareModal={setShowAccountShareModal}
        accountDetails={accountDetails}
      />
    </>
  );
};

export default GuestCommonheader;
